var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_c('strong',[_vm._v(_vm._s(_vm.producer))]),_vm._v(" moved broadcast to the "),_c('strong',[_vm._v(_vm._s(_vm.target))]),_vm._v(" station. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }